// import React from 'react'
// import HomeLayoutListTable from './Componates/HomeLayoutListTable'
// import { NavLink } from 'react-router-dom'
// import { useRoleVerify } from 'Common/RoleVerify';

// const HomeLayoutList = () => {
//     const menu_id = 3;
//     return (
//         <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
//             <div className="row g-3">
//                 <div className="col-sm-12">
//                     <div className="d-flex align-items-center justify-content-between flex-wrap">
//                         <h3 className="fw-bold mb-0">Home Layout List</h3>
//                         {useRoleVerify(menu_id, ["can_create"]) &&
//                             <NavLink to="/admin/add-home-layout" aria-label="User Add" className="btn btn-primary">Add Home Layout</NavLink>
//                         }
//                     </div>
//                 </div>
//                 <div className="col-sm-12">
//                     <div className="card">
//                         <div className="card-body">
//                             <HomeLayoutListTable />
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     )
// }

// export default HomeLayoutList


import React from "react";
import HomeLayoutListTable from "./Componates/HomeLayoutListTable";
import AddItemBtn from "Common/Custom/AddItemBtn";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";


const HomeLayoutList = () => {
  

  return (
    <PageBody
      card={true}
      headerchildren={
        <>
          <HeadingOne>Home Layout List</HeadingOne>
            <AddItemBtn url="add-home-layout" title="Add Home Layout" />
        </>
      }
    >
      {/* Table Section */}
      <div className="col-12">
        <HomeLayoutListTable />
      </div>
    </PageBody>
  );
};

export default HomeLayoutList;
